import React, { useMemo } from 'react';

import { convertProductProps } from '@utils/products';
import { ProductsFeedSleketon } from '@components/ProductsFeedSleketon';
import { ProductDetailsTopSellersProducts } from '@components/product/ProductDetailsTopSellersProducts';

import { useProductDetailsTopSellersProductsQuery } from './gql/graphql.v3.generated';

interface Props {
  className?: string,
  catalogSlug: string,
}

export const ProductDetailsTopSellersProductsContainer: React.FC<Props> = ({
  className,
  catalogSlug,
}) => {
  const { data, loading } = useProductDetailsTopSellersProductsQuery({
    variables: {
      catalogSlug,
      first: 8,
    },
    context: {
      batch: true,
    },
  });

  const products = useMemo(() => {
    return data?.topSellerProducts?.edges?.map((product) => {
      if (product?.node) {
        return convertProductProps(product.node);
      }

      return null;
    }).filter((product) => !!product);
  }, [data?.topSellerProducts]);

  if (loading) {
    return (
      <div className={className}>
        <ProductsFeedSleketon count={4} />
      </div>
    );
  }

  if (products?.length) {
    return (
      <ProductDetailsTopSellersProducts
        className={className}
        products={products}
      />
    );
  }

  return null;
};
